
import findIndex from './findIndex';

function updateAssetItem(assets, asset) {
  if (!assets || assets.length === 0) {return assets;}

  const { assetId } = asset;
  const index = findIndex(assets, assetId);
  const newAssets = [...assets];

  newAssets.splice(index, 1, {
    ...newAssets[index],
    ...asset
  });

  return newAssets;
}

export default updateAssetItem;